module.exports = __webpack_public_path__ + "img/pay.bdae5cbc.png";